import React from 'react';

/**
 * Extracted from `vulcanStructuralComponents.js` into its own leaf module so
 * `fieldRegistry.js` (which `vulcanStructuralComponents.js` itself imports,
 * for `VulcanFormField`) can read it too without an `import/no-cycle`.
 *
 * @typedef {Object} VulcanSectionChrome
 * @property {Object} [expandProps]                 ExpandCollapse render-prop bag (spread on each Panel)
 * @property {(name: string) => boolean} [isSectionVisible]  Explicit visibility override (escape hatch); when omitted, Section derives it live from the engine `form`
 * @property {Object} [visibilityContext]           Non-live ctx for the derived-visibility interpreter (orderData/isFormTouched/multiSelectFieldNames/backendFieldValidationMode)
 * @property {(title: string, name: string) => import('react').ReactNode} [formatControl]  Role-label prefixing
 * @property {(name: string, e: *) => void} [onToggle]       Extra per-section toggle side effect
 * @property {(name: string) => import('react').ReactNode} [renderSectionExtras]  Step-4 VulcanOrderSummary slot
 */
export const VulcanSectionChromeContext = React.createContext(null);

export default VulcanSectionChromeContext;
